module.exports = __webpack_public_path__ + "static/default-cat-banner-736800caf9d3b8271e0e33010836c29d.png";